import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import 'rxjs/add/observable/forkJoin';
import { Observable } from 'rxjs/Observable';
import { environment } from '../../../../../../environments/environment';
import { EventService } from '../../../../../services/event/event.service';
import { HelperService } from '../../../../../services/helper/helper.service';
import {
  UserService,
  UserType
} from '../../../../../services/user/user.service';

@Injectable()
export class AdminService {
  public static UserType = UserType;

  public programmeId = null;
  public _programmeAccess = false;
  public classId = null;
  public programmeDetailsTab = 1;
  public embaName = '';
  public programme = null;

  public userType = UserType;

  get embaSession() {
    if (this.embaName) {
      // return this.helper.fromRoman(this.embaName.split(' ')[1]);
      return this.helper.fromRomanOrNumToNumber(this.embaName.split(' ')[this.embaName.split(' ').length - 1]);
    }
    return 0;
  }

  get programmeAccess() {
    return this.user.isSuperAdmin || this._programmeAccess;
  }
  set programmeAccess(value) {
    this._programmeAccess = value;
  }

  constructor(
    private http: HttpClient,
    private event: EventService,
    private helper: HelperService,
    private user: UserService
  ) {
    this.event.on(
      'admin-service',
      'selectedClassId',
      (classId) => (this.classId = classId)
    );
  }

  createYear(payload, callback) {
    this.http.post('/class', payload).subscribe(
      (res) => {
        callback(null, res);
      },
      (err) => {
        callback(err);
      }
    );
  }

  getMyProfile(callback) {
    this.http.get('/admin').subscribe(
      (res) => {
        callback(null, res);
      },
      (err) => {
        callback(err);
      }
    );
  }

  /**
   * @param type 'course' | 'rlp'
   */
  getParticipants(type, id, page, name, callback) {
    const api = {
      course: '/programme-participant/',
      "current-rlp": '/real-life-project-participant/',
      "parallel-class-rlp": '/real-life-project-parallel-class-participant/',
    };
    const params = { page, name };
    this.http.get(api[type] + id + '/' + this.classId, { params }).subscribe(
      (res) => {
        callback(null, res);
      },
      (err) => {
        callback(err);
      }
    );
  }

  /**
   * @param type 'course' | 'rlp'
   */
  addParticipants(type, payload, callback) {
    const api = {
      course: '/programme-participant',
      rlp: '/real-life-project-participant',
    };
    this.http.post(api[type], payload).subscribe(
      (res) => {
        callback(null, res);
      },
      (err) => {
        callback(err);
      }
    );
  }

  getParallelStudents(id, params, callback) {
    this.http
      .get(`/parallel-students/${id}/${this.classId}`, { params })
      .subscribe(
        (res) => {
          callback(null, res);
        },
        (err) => {
          callback(err);
        }
      );
  }

  /**
   * @param type 'course' | 'rlp'
   */
  addParallelStudent(payload, callback) {
    this.http.post('/parallel-student', payload).subscribe(
      (res) => {
        callback(null, res);
      },
      (err) => {
        callback(err);
      }
    );
  }

  getFromParallelStudent(courseId, classId, params, callback) {
    this.http.get(`/student/classes/${this.classId}`, { params }).subscribe(
      (res) => {
        callback(null, res);
      },
      (err) => {
        callback(err);
      }
    );
  }

  getClassFormat(course_id, callback) {
    this.http.get('/programme-classformat/' + course_id).subscribe(
      (res) => {
        callback(null, res);
      },
      (err) => {
        callback(err);
      }
    );
  }

  addClassFormat(payload, callback) {
    this.http.post('/programme-classformat', payload).subscribe(
      (res) => {
        callback(null, res);
      },
      (err) => {
        callback(err);
      }
    );
  }

  getStudentList(params, callback) {
    params = { ...params };
    this.http.get('/student/classes/' + this.classId, { params }).subscribe(
      (res) => {
        callback(null, res);
      },
      (err) => {
        callback(err);
      }
    );
  }

  getActiveStudentList(params, callback) {
    this.http
      .get('/student/classes-active/' + this.classId, { params })
      .subscribe(
        (res) => {
          callback(null, res);
        },
        (err) => {
          callback(err);
        }
      );
  }

  getAllTeachers(params, callback) {
    this.http.get('/teacher', { params }).subscribe(
      (res) => {
        callback(null, res);
      },
      (err) => {
        callback(err);
      }
    );
  }
  addTeacherToClass(teachers, callback) {
    const payload = {
      user_id: teachers,
      class_id: this.classId,
    };
    this.http.post('/teacher', payload).subscribe((res) => {
      callback(null, res);
    }, callback);
  }

  getTeacherListForProgramme(params, callback) {
    this.http.get('/teacher/classes/' + this.classId, { params }).subscribe(
      (res) => {
        callback(null, res);
      },
      (err) => {
        callback(err);
      }
    );
  }

  updateModule(module, callback) {
    const payload = {
      name: module.name,
      description: module.description,
      visible: module.visible,
      ...(module.data ? { data: module.data } : {}),
    };
    this.http.patch('/module/' + module.id, payload).subscribe(
      (res) => {
        callback(null, res);
      },
      (err) => {
        callback(err);
      }
    );
  }

  updateModuleOrder(data: { id; order }[], callback) {
    const payload = { data };
    this.http.patch('/module/move/all', payload).subscribe(
      (res) => {
        callback(null, res);
      },
      (err) => {
        callback(err);
      }
    );
  }

  getTeacherListForCourse(courseId, page, name, callback) {
    const params = { page, name };
    this.http
      .get('/teacher/course/' + courseId + '/' + this.classId, { params })
      .subscribe(
        (res: any) => {
          res.data = res.data.map((data) => data.user);
          callback(null, res);
        },
        (err) => {
          callback(err);
        }
      );
  }

  getTeacherListForEAFS(eafsId, page, name, callback) {
    const params = { page, name };
    this.http
      .get('/teacher/elective-and-seminar/' + eafsId + '/null', { params })
      .subscribe(
        (res: any) => {
          callback(null, res);
        },
        (err) => {
          callback(err);
        }
      );
  }

  getTeacherListForRLP(rlpId, page, name, callback) {
    const params = { page, name };
    this.http
      .get('/teacher/show-by-real-life-project/' + rlpId + '/' + this.classId, {
        params,
      })
      .subscribe(
        (res: any) => {
          res.data = res.data.map((data) => data.user);
          callback(null, res);
        },
        (err) => {
          callback(err);
        }
      );
  }

  getTeacherList(courseId, type, page, name, callback) {
    const api = type === 'course' ? 'course' : 'show-by-real-life-project';
    const params = { page, name };
    this.http
      .get('/teacher/' + api + '/' + courseId + '/' + this.classId, { params })
      .subscribe(
        (res: any) => {
          res.data = res.data.map((data) => data.user);
          callback(null, res);
        },
        (err) => {
          callback(err);
        }
      );
  }

  getGenericTeacherList(api, params, callback) {
    this.http.get('/teacher/' + api, { params }).subscribe(
      (res: any) => {
        res.data = res.data.map((data) => data.user);
        callback(null, res);
      },
      (err) => {
        callback(err);
      }
    );
  }

  getCourseDetailsForEditing(courseId, callback) {
    Observable.forkJoin(
      this.http.get('/course/' + courseId),
      this.http.get('/teacher/course/' + courseId + '/' + this.classId)
    ).subscribe(
      (res: any) => {
        res[1].data = res[1].data.map((data) => data.user);
        callback(null, {
          courseData: res[0],
          teacherListData: res[1],
        });
      },
      (err) => {
        callback(err);
      }
    );
  }

  getRLPDetailsForEditing(rlpId, callback) {
    Observable.forkJoin(
      this.http.get('/real-life-project/' + rlpId),
      this.http.get(
        '/teacher/show-by-real-life-project/' + rlpId + '/' + this.classId
      )
    ).subscribe(
      (res: any) => {
        res[1].data = res[1].data.map((data) => data.user);
        callback(null, {
          rlpData: res[0],
          teacherListData: res[1],
        });
      },
      (err) => {
        callback(err);
      }
    );
  }

  addCourseDocument(file, callback) {
    const formData = new FormData();
    formData.append('file', file);
    const headers = new HttpHeaders().set('no-content-type', 'true');
    this.http.post('/course/files', formData, { headers }).subscribe(
      (res) => {
        callback(null, res);
      },
      (err) => {
        callback(err);
      }
    );
  }

  removeCourseDocument(file, payload, callback) {
    this.http
      .put(
        '/course/files/' + file.enc_name + '/' + file.extension + '/delete',
        payload
      )
      .subscribe(
        (res) => {
          callback(null, res);
        },
        (err) => {
          callback(err);
        }
      );
  }

  addRLPDocument(file, callback) {
    const formData = new FormData();
    formData.append('file', file);
    const headers = new HttpHeaders().set('no-content-type', 'true');
    this.http.post('/real-life-project/files', formData, { headers }).subscribe(
      (res) => {
        callback(null, res);
      },
      (err) => {
        callback(err);
      }
    );
  }

  removeRLPDocument(file, payload, callback) {
    this.http
      .put(
        '/real-life-project/files/' +
        file.enc_name +
        '/' +
        file.extension +
        '/delete',
        payload
      )
      .subscribe(
        (res) => {
          callback(null, res);
        },
        (err) => {
          callback(err);
        }
      );
  }

  addExamFile(file, callback) {
    const formData = new FormData();
    formData.append('file', file);
    const headers = new HttpHeaders().set('no-content-type', 'true');
    this.http.post('/exam/files', formData, { headers }).subscribe(
      (res) => {
        callback(null, res);
      },
      (err) => {
        callback(err);
      }
    );
  }

  removeExamFile(file, payload, callback) {
    this.http
      .put(
        '/exam/files/' + file.enc_name + '/' + file.extension + '/delete',
        payload
      )
      .subscribe(
        (res) => {
          callback(null, res);
        },
        (err) => {
          callback(err);
        }
      );
  }

  addDiplomaPaperDocument(file, callback) {
    const formData = new FormData();
    formData.append('file', file);
    const headers = new HttpHeaders().set('no-content-type', 'true');
    this.http.post('/diploma-paper/files', formData, { headers }).subscribe(
      (res) => {
        callback(null, res);
      },
      (err) => {
        callback(err);
      }
    );
  }

  removeDiplomaPaperDocument(file, payload, callback) {
    this.http
      .put(
        '/diploma-paper/files/' +
        file.enc_name +
        '/' +
        file.extension +
        '/delete',
        payload
      )
      .subscribe(
        (res) => {
          callback(null, res);
        },
        (err) => {
          callback(err);
        }
      );
  }

  addEAFSDocument(file, callback) {
    const formData = new FormData();
    formData.append('file', file);
    const headers = new HttpHeaders().set('no-content-type', 'true');
    this.http.post('/elective-and-seminar', formData, { headers }).subscribe(
      (res) => {
        callback(null, res);
      },
      (err) => {
        callback(err);
      }
    );
  }

  removeEAFSDocument(file, payload, callback) {
    this.http
      .put(
        '/elective-and-seminar/files/' +
        file.enc_name +
        '/' +
        file.extension +
        '/delete',
        payload
      )
      .subscribe(
        (res) => {
          callback(null, res);
        },
        (err) => {
          callback(err);
        }
      );
  }


  addEAFSExamFile(file, callback) {
    const formData = new FormData();
    formData.append('file', file);
    const headers = new HttpHeaders().set('no-content-type', 'true');
    this.http.post('/elective-and-seminar-exam/files', formData, { headers }).subscribe(
      (res) => {
        callback(null, res);
      },
      (err) => {
        callback(err);
      }
    );
  }

  removeEAFSExamFile(file, payload, callback) {
    this.http
      .put(
        '/elective-and-seminar-exam/files/' + file.enc_name + '/' + file.extension + '/delete',
        payload
      )
      .subscribe(
        (res) => {
          callback(null, res);
        },
        (err) => {
          callback(err);
        }
      );
  }

  sendInvitationLinkToTeacher(email, callback) {
    const payload = {
      email,
      type: UserType.TEACHER + '',
      class_id: this.classId,
      link: environment.teacherUrl + '/signup/complete/',
    };
    this.http.patch('/user/sent-invitation', payload).subscribe(
      (res) => {
        callback(null, res);
      },
      (err) => {
        callback(err);
      }
    );
  }

  sendInvitationLinkToStudent(email, callback) {
    const payload = {
      email,
      type: UserType.STUDENT + '',
      class_id: this.classId,
      link: environment.studentUrl + '/signup/complete/',
    };
    this.http.patch('/user/sent-invitation', payload).subscribe(
      (res) => {
        callback(null, res);
      },
      (err) => {
        callback(err);
      }
    );
  }

  sendInvitationLinkToMultipleStudent(emailList, callback) {
    this.sendInvitationLinkToMultipleUser(
      emailList,
      UserType.STUDENT,
      callback
    );
  }

  sendInvitationLinkToMultipleTeacher(emailList, callback) {
    this.sendInvitationLinkToMultipleUser(
      emailList,
      UserType.TEACHER,
      callback
    );
  }

  sendInvitationLinkToMultipleUser(emailList, userType, callback) {
    const baseUrl =
      userType == UserType.TEACHER
        ? environment.teacherUrl
        : environment.studentUrl;
    const payloads = emailList.map((email) => ({
      email,
      type: userType + '',
      class_id: this.classId,
      link: baseUrl + '/signup/complete/',
    }));
    const requests = payloads.map((payload) => {
      return this.http.patch('/user/sent-invitation', payload);
    });
    // Observable.forkJoin(...requests).pipe(
    //   res => {
    //     callback(null, res);
    //   },
    //   callback
    // );
    const indexes = [];
    const cb = (err, index) => {
      if (err) {
        let error = '';
        if (err.status_code >= 500) {
          error = 'Error sending mail';
        } else if (err.message) {
          error = err.message;
        } else if (err.errmsg) {
          const msg = err.errmsg;
          if (typeof msg === 'string') {
            error = msg;
          } else {
            error = msg[Object.keys(msg)[0]][0];
          }
        } else {
          error = 'Error sending mail';
        }
        console.log(error, err);
        indexes.push({ index, error });
      }
      if (index === payloads.length - 1) {
        callback(indexes.length && indexes);
      }
    };
    const headers = new HttpHeaders().set('no-error-handling', '1');
    payloads.forEach((payload, index) => {
      this.http.patch('/user/sent-invitation', payload, { headers }).subscribe(
        (res) => {
          cb(null, index);
        },
        (err) => {
          cb(err, index);
        }
      );
    });
  }

  updateCourse(courseId, payload, callback) {
    this.http.patch('/course/' + courseId, payload).subscribe(
      (res) => {
        callback(null, res);
      },
      (err) => {
        callback(err);
      }
    );
  }

  updateModuleAndCourse(course, module, callback) {
    const coursePayload = course;
    const modulePayload = {
      name: module.name,
      description: module.description,
      visible: module.visible,
    };
    Observable.forkJoin(
      this.http.patch('/course/' + course.id, coursePayload),
      this.http.patch('/module/' + module.id, modulePayload)
    ).subscribe(
      (res) => {
        const response = {
          courseResponse: res[0],
          moduleResponse: res[1],
        };
        callback(null, response);
      },
      (err) => {
        callback(err);
      }
    );
  }

  getCourseDetails(courseId, callback) {
    this.http.get('/course/details/' + courseId).subscribe(
      (res: any) => {
        if (Array.isArray(res)) {
          callback(null);
        } else {
          const course = {
            name: res.name,
            description: res.description,
            assigned_teacher: res.assign_teacher.map(
              (teacher) => teacher.user && teacher.user.name
            ),
            data: res.data,
            exam: res.exam.map((exam) => exam.exam_name),
            module_name: res.module.name,
            module_description: res.module.description,
            classes: res.classes,
            docs: [].concat(
              ...(res.course_files || []),
              ...res.course_file.map((data) => data.file)
            ),
            videos: res.course_video.map((data) => data.file),
            links: res.course_link.map((data) => data.file),
            event: res.event,
            start_date: res.available_from,
            end_date: res.available_till,
            publish_evaluate_sheet: res.publish_evaluate_sheet,
          };
          callback(null, course);
        }
      },
      (err) => {
        callback(err);
      }
    );
  }

  getExamDetails(examId, callback) {
    this.http.get('/exam/' + examId).subscribe(
      (res) => callback(null, res),
      (err) => callback(err)
    );
  }

  getDiplomaPaperDetails(diplomaPaperId, callback) {
    this.http.get('/diploma-paper/' + diplomaPaperId).subscribe(
      (res) => callback(null, res),
      (err) => callback(err)
    );
  }

  getRlpDetails(rlpId, callback) {
    this.http.get('/real-life-project/' + rlpId).subscribe(
      (res) => {
        callback(null, Array.isArray(res) ? null : res);
      },
      (err) => {
        callback(err);
      }
    );
  }

  getClassDetails(classId, callback) {
    this.http.get('/class/' + classId).subscribe(
      (res) => {
        callback(null, res);
      },
      (err) => {
        callback(err);
      }
    );
  }

  updateClass(classId, payload, callback) {
    this.http.put('/class/' + classId, payload).subscribe(
      (res) => {
        callback(null, res);
      },
      (err) => {
        callback(err);
      }
    );
  }

  updateRLP(payload, callback) {
    this.http
      .put('/real-life-project/' + payload.id, payload)
      .subscribe((res) => {
        callback(null, res);
      }, callback);
  }

  getStudentDetails(id, callback) {
    this.http.get('/student/' + id).subscribe(
      (res) => {
        callback(null, res);
      },
      (err) => {
        callback(err);
      }
    );
  }

  getTeacherDetails(id, callback) {
    const api =
      this.user.isSuperAdmin && false
        ? '/bmi-super-admin/teacher/' + id
        : '/teacher/' + id;
    this.http.get(api).subscribe(
      (res) => {
        callback(null, res);
      },
      (err) => {
        callback(err);
      }
    );
  }

  changeUserStatus(userId, status, callback) {
    this.http.patch('/user/status/' + userId, { status }).subscribe((res) => {
      callback(null, res);
    }, callback);
  }

  importModule(toClassId, moduleId, callback) {
    const payload = {
      to_class_id: toClassId,
      module_id: moduleId,
    };
    this.http.post('/bmi-import/module', payload).subscribe(
      (res) => {
        callback(null, res);
      },
      (err) => {
        callback(err);
      }
    );
  }

  importDiplomaPaper(fromClassId, toClassId, callback) {
    const payload = {
      to_class_id: toClassId,
      from_class_id: fromClassId,
    };
    this.http.post('/bmi-import/diploma-paper', payload).subscribe(
      (res) => {
        callback(null, res);
      },
      (err) => {
        callback(err);
      }
    );
  }

  importStudyDocs(fromClassId, toClassId, callback) {
    const payload = {
      to_class_id: toClassId,
      from_class_id: fromClassId,
    };
    this.http.post('/bmi-import/study-document', payload).subscribe(
      (res) => {
        callback(null, res);
      },
      (err) => {
        callback(err);
      }
    );
  }

  deleteModule(id, callback) {
    this.http.delete('/module/' + id).subscribe((res) => {
      callback(null, res);
    }, callback);
  }

  deleteCourse(id, callback) {
    this.http.delete('/course/' + id).subscribe((res) => {
      callback(null, res);
    }, callback);
  }

  deleteRLP(id, callback) {
    this.http.delete('/real-life-project/' + id).subscribe((res) => {
      callback(null, res);
    }, callback);
  }

  deleteExam(id, callback) {
    this.http.delete('/exam/' + id).subscribe((res) => {
      callback(null, res);
    }, callback);
  }

  getAttendanceData(courseId, date, page, name, classId, type, callback) {
    const when = this.getWhenParamFromType(type);
    const params = { date, page, name, when, class_id: classId };
    this.http.get('/attendance/' + courseId, { params }).subscribe((res) => {
      callback(null, res);
    }, callback);
  }

  private getWhenParamFromType(type: any) {
    return type === 'current'
      ? 'current_class'
      : type === 'previous-class'
        ? 'alumni'
        : type === 'guest'
          ? 'exchange_student'
          : type === 'parallel-class'
            ? 'parallel_student'
            : '';
  }

  saveAttendanceData(payload, callback) {
    this.http.post('/attendance', payload).subscribe((res) => {
      callback(null, res);
    }, callback);
  }

  getExamTypes(callback) {
    this.http.get('/exam/type/all').subscribe(
      (res) => {
        callback(null, res);
      },
      (err) => {
        callback(err);
      }
    );
  }

  getExamTypeDetails(id, callback) {
    this.http.get('/exam/type/find/' + id).subscribe((res) => {
      callback(null, res);
    }, callback);
  }

  getGradesData(page, name, type, examId, courseId, callback) {
    const when = this.getWhenParamFromType(type);
    const params = {
      page,
      name,
      when,
      course_id: courseId,
      class_id: this.classId,
    };
    this.http.get('/grade/' + examId, { params }).subscribe((res) => {
      callback(null, res);
    }, callback);
  }

  saveGradesData(payload, callback) {
    this.http.post('/grade', payload).subscribe((res) => {
      callback(null, res);
    }, callback);
  }

  getRLPGradesData(page, name, is_exchange, rlpId, type, callback) {
    const params = { page, name, is_exchange, class_id: this.classId };
    if (type == 'parallel-class') {
      this.http.get('/rlp-parallel-grade/' + rlpId, { params }).subscribe((res) => {
        callback(null, res);
      }, callback);
    }
    else
      this.http.get('/rlp-grade/' + rlpId, { params }).subscribe((res) => {
        callback(null, res);
      }, callback);
  }

  saveRLPGradesData(payload, callback) {
    this.http.post('/rlp-grade', payload).subscribe((res) => {
      callback(null, res);
    }, callback);
  }

  getDiplomaPaperGradesData(page, name, is_exchange, diplomaPaperId, callback) {
    const params = { page, name, is_exchange, class_id: this.classId };
    this.http
      .get('/dp-grade/' + diplomaPaperId, { params })
      .subscribe((res) => {
        callback(null, res);
      }, callback);
  }

  saveDiplomaPaperGradesData(payload, callback) {
    this.http.post('/dp-grade', payload).subscribe((res) => {
      callback(null, res);
    }, callback);
  }

  registerStudent(payload, callback) {
    payload = {
      ...payload,
      type: UserType.STUDENT + '',
      class_id: this.classId,
    };
    const formData = new FormData();
    Object.keys(payload).forEach((key) => formData.append(key, payload[key]));
    let headers = new HttpHeaders();
    headers = headers.set('no-content-type', 'true');
    this.http.post('/user/register', formData, { headers }).subscribe((res) => {
      callback(null, res);
    }, callback);
  }

  registerTeacher(payload, callback) {
    payload = {
      ...payload,
      type: UserType.TEACHER + '',
    };
    const formData = new FormData();
    Object.keys(payload).forEach((key) => formData.append(key, payload[key]));
    let headers = new HttpHeaders();
    headers = headers.set('no-content-type', 'true');
    this.http
      .post('/teacher/register', formData, { headers })
      .subscribe((res) => {
        callback(null, res);
      }, callback);
  }

  registerExchangeStudent(payload, callback) {
    payload = {
      ...payload,
      type: UserType.STUDENT + '',
      class_id: this.classId,
    };
    const formData = new FormData();
    Object.keys(payload).forEach((key) => formData.append(key, payload[key]));
    let headers = new HttpHeaders();
    headers = headers.set('no-content-type', 'true');
    this.http
      .post('/guest-student/user', formData, { headers })
      .subscribe((res) => {
        callback(null, res);
      }, callback);
  }

  genericRegisterStudent(api, payload, callback) {
    payload = {
      ...payload,
      type: UserType.STUDENT + '',
      class_id: this.classId,
    };
    const formData = new FormData();
    Object.keys(payload).forEach((key) => formData.append(key, payload[key]));
    let headers = new HttpHeaders();
    headers = headers.set('no-content-type', 'true');
    this.http.post(api, formData, { headers }).subscribe((res) => {
      callback(null, res);
    }, callback);
  }

  getExam(id, callback) {
    this.http.get('/exam/' + id).subscribe((res) => {
      callback(null, res);
    }, callback);
  }

  updateExam(exam, callback) {
    this.http.put('/exam/' + exam.id, exam).subscribe((res) => {
      callback(null, res);
    }, callback);
  }

  getMyClass(callback) {
    this.http
      .get('/my-class')
      .subscribe((res) => callback(null, res), callback);
  }

  saveGeneratedPassword(
    password: string,
    userType: UserType,
    noClassId: boolean,
    callback
  ) {
    const payload = {
      type: userType + '',
      password,
    };
    if (userType == UserType.STUDENT && !noClassId) {
      payload['class_id'] = this.classId;
    }
    this.http.put('/user/master-password', payload).subscribe(
      (res) => callback(null, res),
      (err) => this.helper.handleError(err, 'warning') && callback(err)
    );
  }

  getNotifications(page, callback) {
    const params = {
      page,
    };
    this.http.get('/bmi-notification', { params }).subscribe(
      (res) => callback(null, res),
      (err) => callback(err)
    );
  }

  deleteNotification(notificationId, callback) {
    this.http.delete('/bmi-notification/' + notificationId).subscribe(
      (res) => callback(null, res),
      (err) => this.helper.handleError(err, 'error') && callback(err)
    );
  }

  updateRlpType(rlpId, payload, callback) {
    // http://bmiapi.com/api/bmi-admin/rlp-type/1
    this.http.put('/rlp-type/' + rlpId, payload).subscribe(
      (res) => callback(null, res),
      (err) => this.helper.handleError(err, 'error') && callback(err)
    );
  }

  deleteRLPType(id, callback) {
    this.http.delete('/rlp-type/' + id).subscribe(
      (res) => callback(null, res),
      (err) => this.helper.handleError(err, 'error') && callback(err)
    );
  }

  updateUserId(
    userType: 'student' | 'alumni' | 'guest',
    origId: number,
    id: number,
    callback
  ) {
    const key = {
      student: 'student_id',
      alumni: 'alumni_id',
      guest: 'student_id'
    }[userType];
    const apiUrl = {
      student: `/student/id/${origId}`,
      alumni: `/alumni/id/${origId}`,
      guest: `/guest-student/user/id/${origId}`
    }[userType];
    const payload = {
      [key]: id,
    };
    this.http.patch(apiUrl, payload).subscribe(
      (res) => callback(null, res),
      (err) => this.helper.handleError(err, 'warning') && callback(err)
    );
  }

  getAutocomplete(type: string, term: string, extraParams: any = {}) {
    // http://bmiapi.com/api/bmi-admin/autocomplete/course?data=Intro
    const params = {
      data: term,
      ...extraParams,
    };
    return this.http.get(`/autocomplete/${type}`, { params });
  }
  getAutocompleteWithParams(type: string, params: any = {}) {
    return this.http.get(`/autocomplete/${type}`, { params });
  }

  getClassListWithProgrammes(callback) {
    const params = { page: '1' };
    this.http.get('/class', { params }).subscribe(
      (res) => callback(null, res),
      (err) => this.helper.handleError(err, 'error') && callback(err)
    );
  }

  getClassListWithProgrammesWithParams(params, callback) {
    params = { ...params, page: '1' };
    this.http.get('/class', { params }).subscribe(
      (res) => callback(null, res),
      (err) => this.helper.handleError(err, 'error') && callback(err)
    );
  }

  moveCourse(courseId, moduleId, callback) {
    const payload = {
      module_id: moduleId,
    };
    return this.http.patch(`/course/${courseId}/move`, payload).subscribe(
      (res) => callback(null, res),
      (err) => this.helper.handleError(err, 'error') && callback(err)
    );
  }

  updateCourseOrderInModule(data, callback) {
    const payload = {
      data,
    };
    return this.http.patch(`/course/move/order`, payload).subscribe(
      (res) => callback(null, res),
      (err) => this.helper.handleError(err, 'error') && callback(err)
    );
  }

  toggleModuleVisibility(moduleId, callback) {
    return this.http.put(`/module/visibility-change/${moduleId}`, {}).subscribe(
      (res) => callback(null, res),
      (err) => this.helper.handleError(err, 'error') && callback(err)
    );
  }
  toggleCourseVisibility(courseId, callback) {
    return this.http.put(`/course/visibility-change/${courseId}`, {}).subscribe(
      (res) => callback(null, res),
      (err) => this.helper.handleError(err, 'error') && callback(err)
    );
  }
}



// WEBPACK FOOTER //
// G:/UTL/BMI/Admin/Admin-ANG/src/app/layout/modules/admin/services/admin/admin.service.ts